import React from "react";
import icon_loading_data from "./loading-lottie.json";
import SSRLottie from "./SSRLottie";

// https://www.figma.com/design/xnr558XUCXb4vkBy6eAif7/%5B%EB%9D%BC%EC%9D%B4%EB%B8%8C%EB%9F%AC%EB%A6%AC%5D-Potoo-Library?node-id=1570-565&t=3lunUvpzgaQBTI5S-4
const PotooLoadingAnimation = ({}) => {
  return (
    <div>
      <SSRLottie animationData={icon_loading_data} style={{ width: 48 }} />
    </div>
  );
};

export { PotooLoadingAnimation };
